export default "__VITE_ASSET__DoHYUS26__"